import FormInput from "@components/Form/FormInput";
import FormTextarea from "@components/Form/FormTextarea";
import { StyledButton } from "@components/Styled/Button";
import { StyledH2, StyledXSmall } from "@components/Styled/Text";
import { css } from "@emotion/react";
import React from "react";
import tw, { styled } from "twin.macro";
import { withQuestionsForm } from "./withQuestionsForm";

const Wrapper = tw.form`
  flex flex-wrap w-full px-midi text-hint md:px-zero md:text-body
`;
const Header = tw(StyledH2)`
  w-full mb-midi text-center md:text-[44px]
`;
const Column = tw.div`
  w-full md:w-1/2 md:px-mini
`;
const Button = tw(StyledButton)`
  w-full md:max-w-33
`;
const Input = styled(FormInput)`
  ${tw`px-zero mb-midi h-auto`}
  ${({ error }) =>
    error
      ? css`
          ${tw`mb-zero`}
          & input {
            ${tw`border-b-2 text-warning border-warning`}
          }
        `
      : null}
`;

const TextareaWrapper = tw.div`
  w-full md:px-mini
`;
const Textarea = styled(FormTextarea)`
  ${tw`mb-midi px-zero`}
  ${({ error }) =>
    error
      ? css`
          ${tw`mb-zero`}
          & textarea {
            ${tw`border-b-2 text-warning border-warning`}
          }
        `
      : null}
`;

const ButtonWrapper = tw.div`
  w-full flex flex-wrap px-mini items-center justify-center
`;
const ErrorMessage = tw(StyledXSmall)`
  mb-mini text-warning mt-pico
`;
const Success = tw.div`
  py-midi md:py-mega flex flex-col items-center justify-center
`;
const Title = tw.h2`
  text-center text-h2 md:text-[44px] font-display mb-mini
`;
const Message = tw.p`
  mx-auto text-center leading-caption mb-mini
`;
const HelperTextContent = tw.div`
  w-full flex justify-center leading-body mb-midi md:mb-maxi
`;

const QuestionsForm = withQuestionsForm(
  ({
    data,
    handleChange,
    handleSubmit,
    className,
    loading,
    success,
    errors,
  }) => {
    return !success ? (
      <Wrapper className={className}>
        <Header>Ask a question</Header>
        <HelperTextContent className="rte">
          <div className="px-4 text-center">
            <p>Need your question answered sooner?</p>
            <p>
              <a href="/contact">Get in Touch</a>
            </p>
          </div>
        </HelperTextContent>
        <Column>
          <Input
            data-testid="name"
            label="Name"
            name="name"
            value={data.name}
            handleChange={handleChange}
            error={!!errors["name"]}
            required
          />
          {errors["name"] ? (
            <ErrorMessage>{errors["name"]}</ErrorMessage>
          ) : null}
        </Column>
        <Column>
          <Input
            data-testid="email"
            label="Email"
            name="email"
            value={data.email}
            handleChange={handleChange}
            error={!!errors["email"]}
            required
          />
          {errors["email"] ? (
            <ErrorMessage>{errors["email"]}</ErrorMessage>
          ) : null}
        </Column>
        <TextareaWrapper>
          <Textarea
            data-testid="question"
            label="Question"
            name="content"
            value={data.content}
            handleChange={handleChange}
            error={!!errors["content"]}
            required
          />
          {errors["content"] ? (
            <ErrorMessage>{errors["content"]}</ErrorMessage>
          ) : null}
        </TextareaWrapper>

        <ButtonWrapper>
          <Button
            height="56"
            textSize="16"
            colour="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting" : "Submit"}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    ) : (
      <Success>
        <Title>Thanks for your question!</Title>
        <Message>
          We love hearing from you. Our team will publish it shortly.
        </Message>
      </Success>
    );
  },
);

export default QuestionsForm;
